// Receipt pages from the voucher templates (@xr/templates), as the prototype's 32-pdf.js pdfStack()
// and pdfFit(): page HTML scaled to the width it gets, amounts given the dirham symbol.
import { dhApply } from '@xr/ui';
import { useLayoutEffect, useRef } from 'react';

export const pdfStack = (pages: string[], zoom: 'fit' | '1' = 'fit') =>
  `<div class="xv" dir="ltr" data-zoom="${zoom}">${pages.map((p, i) => `<div class="xv-pw" data-pg="${i + 1}"><div class="xv-ps">${p}</div></div>`).join('')}</div>`;

export function pdfFit(root: HTMLElement) {
  root.querySelectorAll<HTMLElement>('.xv').forEach(v => {
    const avail = v.clientWidth; if (!avail) return;
    v.querySelectorAll<HTMLElement>('.xv-pw').forEach(w => {
      const ps = w.firstElementChild as HTMLElement | null, pp = ps?.firstElementChild as HTMLElement | null; if (!ps || !pp) return;
      const pw = pp.offsetWidth, ph = pp.offsetHeight;
      const s = v.dataset.zoom === '1' ? 1 : Math.min(1, (avail - 2) / pw);
      ps.style.transform = `scale(${s})`; w.style.width = pw * s + 'px'; w.style.height = ph * s + 'px';
    });
  });
}

/** Puts template HTML in the element, gives amounts the dirham symbol and keeps the pages fitted. */
export function useVoucherHtml<E extends HTMLElement>(html: string) {
  const ref = useRef<E>(null);
  useLayoutEffect(() => {
    const el = ref.current; if (!el) return;
    el.innerHTML = html;
    dhApply(el);
    const go = () => el.isConnected && pdfFit(el);
    go(); const raf = requestAnimationFrame(go); const id = setTimeout(go, 300);
    void document.fonts?.ready.then(go);
    window.addEventListener('resize', go);
    return () => { cancelAnimationFrame(raf); clearTimeout(id); window.removeEventListener('resize', go); };
  }, [html]);
  return ref;
}
